import { lazy, type ComponentType } from 'react';

export const CHUNK_RELOAD_KEY = 'chunk-reload';

type LazyModule<T extends ComponentType<unknown>> = { default: T };

export function lazyWithRetry<T extends ComponentType<unknown>>(
  importFn: () => Promise<LazyModule<T>>
) {
  return lazy(() =>
    importFn().catch((error: unknown) => {
      const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);
      if (!hasReloaded) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
        window.location.reload();
        return { default: (() => null) as unknown as T };
      }
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      throw error;
    })
  );
}

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const msg = error.message.toLowerCase();
  return (
    msg.includes('failed to fetch dynamically imported module') ||
    msg.includes('importing a module script failed') ||
    msg.includes('error loading dynamically imported module')
  );
}

export function retryChunkLoadOnce(): boolean {
  const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);
  if (!hasReloaded) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
    window.location.reload();
    return true;
  }
  return false;
}
